import {
  NEWQUANLYTONKHO_COUNT_ASSIGN_SUCCESS,
  NEWQUANLYTONKHO_HISTORY_LIST_SUCCESS,
  NEWQUANLYTONKHO_IMPORT_SUCCESS,
  NEWQUANLYTONKHO_LIST_SUCCESS,
  NEWQUANLYTONKHO_NEW_CARE_SUCCESS,
  NEWQUANLYTONKHO_ONE_SUCCESS,
  NEWQUANLYTONKHO_LAYDANHSACHTON_SUCCESS,
  NEWQUANLYTONKHO_UPDATE_FILTER,
  NEWQUANLYTONKHO_SAVE_SUCCESS,
  NEWQUANLYTONKHO_UPDATE_HOMEPAGE_FILTER,
  NEWQUANLYTONKHO_HOMEPAGE_LIST_SUCCESS,
  NEWQUANLYTONKHO_HOMEPAGE_ONE_SUCCESS,
  NEWQUANLYTONKHO_HANDLE_IMPORT_ERRORS,
} from 'src/actions/newquanlytonkho.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageNewquanlytonkhoFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageNewquanlytonkhoPage: 0,
    homepageNewquanlytonkhoLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  selected_laydanhsachton: undefined,
  homepageNewquanlytonkhoItems: [],
  homepageNewquanlytonkhoTotal: 0,
  homepageNewquanlytonkhoSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
  errorRows: {},
}

const newquanlytonkhoReducer = (state = initState, action) => {
  switch (action.type) {
    case NEWQUANLYTONKHO_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case NEWQUANLYTONKHO_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case NEWQUANLYTONKHO_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case NEWQUANLYTONKHO_LAYDANHSACHTON_SUCCESS: {
      return {
        ...state,
        selected_laydanhsachton: action.data
      }
    }
    case NEWQUANLYTONKHO_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageNewquanlytonkhoFilter !== 'undefined' && state.homepageNewquanlytonkhoFilter) {
        if (action.data.homepageNewquanlytonkhoPage == 'no_update' && typeof state.homepageNewquanlytonkhoFilter.homepageNewquanlytonkhoPage !== 'undefined') action.data.homepageNewquanlytonkhoPage = state.homepageNewquanlytonkhoFilter.homepageNewquanlytonkhoPage;
        if (action.data.homepageNewquanlytonkhoLimit == 'no_update' && typeof state.homepageNewquanlytonkhoFilter.homepageNewquanlytonkhoLimit !== 'undefined') action.data.homepageNewquanlytonkhoLimit = state.homepageNewquanlytonkhoFilter.homepageNewquanlytonkhoLimit;
      }
      return {
        ...state,
        homepageNewquanlytonkhoFilter: action.data,
      }
    }
    case NEWQUANLYTONKHO_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageNewquanlytonkhoItems: action.data.homepageNewquanlytonkhoItems,
        homepageNewquanlytonkhoTotal: action.data.homepageNewquanlytonkhoTotal,
      }
    }
    case NEWQUANLYTONKHO_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageNewquanlytonkhoSelected: action.data
      }
    }
    case NEWQUANLYTONKHO_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case NEWQUANLYTONKHO_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case NEWQUANLYTONKHO_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case NEWQUANLYTONKHO_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case NEWQUANLYTONKHO_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    case NEWQUANLYTONKHO_HANDLE_IMPORT_ERRORS: {
      return {
        ...state,
        errorRows: action.data,
      }
    }
    default: {
      return state;
    }
  }
}
export default newquanlytonkhoReducer